
<div>
    <template v-if="cta">
        <button href="#"
            class="btn btn-primary d-flex flex-nowrap align-items-center justify-content-center"
            :style="`background-color: ${cta};`"
            :disabled="status.downloading"
            @click.prevent="manageAction">

            <span class="pe-3" v-html="cta"></span>

            <template v-if="status.downloading">
                <div class="spinner-border spinner-border-sm" role="status" style="font-size: 12px;">
                    <span class="sr-only">Loading...</span>
                </div>
            </template>

            <img src="https://asurcloudrunprod-16905.kxcdn.com/public-assets/right-arrow-icon" class='arrow-icon' width="18" height="18" v-else/>
        </button>
    </template>

    <LoginModal ref="loginModal" :cta="cta" @sendEmail="sendEmail"/>
</div>
